import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { AllLayout } from "./screens/AllLayout";
import MainHomePage from "./screens/homepage/main";
import ServicePage from "./screens/homepage/service";
import ServicePosPage from "./screens/servicePage/pos";
import ServiceKdsPage from "./screens/servicePage/kds";
import ServiceKioskPage from "./screens/servicePage/kiosk";
import ServiceDidPage from "./screens/servicePage/did";
import ServiceTableOrederPage from "./screens/servicePage/tableOreder";
import ServiceOnlineOrederPage from "./screens/servicePage/onlineOreder";
import ContactPage from "./screens/contactPage/contact";

const App = () => {
  useEffect(() => {}, []);

  return (
    <Routes>
      <Route path="/" element={<AllLayout />}>
        <Route path="/" element={<MainHomePage />} />

        {/* service */}
        <Route path="/service" element={<ServicePage />} />
        <Route path="/pos" element={<ServicePosPage />} />
        <Route path="/kds" element={<ServiceKdsPage />} />
        <Route path="/kiosk" element={<ServiceKioskPage />} />
        <Route path="/did" element={<ServiceDidPage />} />
        <Route path="/tableOreder" element={<ServiceTableOrederPage />} />
        <Route path="/onlineOreder" element={<ServiceOnlineOrederPage />} />
        
        {/* contact */}
        <Route path="/contact" element={<ContactPage />} />
      </Route>
    </Routes>
  );
};

export default App;
